export const AuthStatus = Object.freeze({
    AUTHENTICATED: 'AUTHENTICATED',
    REQUIRE_MAIL_VERIFICATION: 'REQUIRE_MAIL_VERIFICATION',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
});
